import { render, staticRenderFns } from "./QsCounter.vue?vue&type=template&id=4a6b7851&scoped=true&"
import script from "./QsCounter.vue?vue&type=script&lang=js&"
export * from "./QsCounter.vue?vue&type=script&lang=js&"
import style0 from "./QsCounter.vue?vue&type=style&index=0&id=4a6b7851&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b7851",
  null
  
)

export default component.exports